 <!-- ======= Services Section ======= -->
    <section id="services" class="services">
      <div class="container mb-80" data-aos="fade-up">

        <div class="section-title text-center pt-120 pb-50">
                        <h5 class="sub-title mb-15" data-aos="fade-up" data-aos-duration="3000">Our Values</h5>
                        <h2 class="title" data-aos="fade-up" data-aos-duration="3000">The Key On Every Dealing</h2>
                    </div>

        <div class="row">
          <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mb-4 mt-md-0" data-aos="zoom-in" data-aos-delay="100">
            <div class="icon-box">
              <div class="icon"><i class="lni-license"/></div>
              <h4>Legal</h4>
              <p>We have business permit which is given by Ministry of Law of the Republic of Indonesia.</p>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mb-4 mt-md-0" data-aos="zoom-in" data-aos-delay="100">
            <div class="icon-box">
              <div class="icon"><i class="lni-handshake"/></div>
              <h4>Trusted</h4>
              <p>Perform trading activities based on system operational procedures.</p>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mb-4 mt-md-0" data-aos="zoom-in" data-aos-delay="100">
            <div class="icon-box">
              <div class="icon"><i class="lni-customer"/></div>
              <h4>Quality</h4>
              <p>Provide best quality for every product and prioritize customer satisfaction.</p>
            </div>
          </div>

          

        </div>

      </div>
    </section><!-- End Services Section -->

    <style>
    /*--------------------------------------------------------------
# Services
--------------------------------------------------------------*/
.services .icon-box {
  text-align: center;
  border: 1px solid #e2eefd;
  padding: 80px 20px;
  transition: all ease-in-out 0.3s;
  background: #fff;
}

.services .icon-box .icon {
  margin: 0 auto;
  width: 64px;
  height: 64px;
  background: #f1f6fe;
  border-radius: 4px;
  border: 1px solid #deebfd;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  transition: ease-in-out 0.3s;
}

.services .icon-box .icon i {
  color: #01264C;
  font-size: 28px;
  transition: ease-in-out 0.3s;
}

.services .icon-box h4 {
  font-weight: 700;
  margin-bottom: 15px;
  font-size: 24px;
  color: #222222;
  transition: ease-in-out 0.3s;
}

.services .icon-box p {
  line-height: 24px;
  font-size: large;
  margin-bottom: 0;
}

.services .icon-box:hover {
  border-color: #fff;
  box-shadow: 0px 0 25px 0 rgba(1,38,76,0.3);;
}

.services .icon-box:hover h4 a, .services .icon-box:hover .icon i {
  color: #01264C;
}

.services .icon-box:hover .icon {
  border-color: #01264C;
}
    </style>